import DebugLogger from "../../../../../utils/DebugLogger";
import Recorder from "js-audio-recorder";
import _ from "lodash";
import { NativeEventEmitter } from "react-native-web";
import SpeechServiceFactory from "./SpeechServiceFactory";
import { encodeWAV } from "./wavHelper";
import localStorageFileHelper from "../../../../../utils/LocalStorageFileHelper";
import * as Helper from "../../../../../utils/Helper";

import Mp3Recorder from 'recorder-core';
import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';

const callCallback = (handler, param) => {
    if (handler && _.isFunction(handler)) {
        handler(param);
    }
};

/**
 * Created by JIA on 2022/8/18.
 */
class RNSpeechRecognizeWeb {
    constructor() {
        this.localVars = {
            recorder: null,
            currentState: 0,
            currentVol: 0,
            currentConfig: {},
            wavFilePath: "temp.wav",
            serviceFactory: null,
            needSplitAudio: false,
            isInitialized: false,
            isRecording: false,
            eventEmitter: new NativeEventEmitter(),
            startRecognizeCallback: null,
        };
    }

    startRecognize = onStarted => {
        if (!this.localVars.isInitialized) {
            //return Promise.reject("Please init first");
            return Promise.reject(new Error("Please init first"));
        }
        return new Promise((resolve, reject) => {
            if (this.localVars.mp3Recorder) {
                this.localVars.mp3Recorder.close();
                this.localVars.mp3Recorder = null;
            }

            if (this.localVars.enableMp3Encoder) {
                this.localVars.mp3Recorder = Mp3Recorder({
                    type: "mp3",
                    sampleRate: 16000,
                    bitRate: 16,
                    onProcess: (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
                        //录音实时回调，大约1秒调用12次本回调，buffers为开始到现在的所有录音pcm数据块(16位小端LE)
                        //可利用extensions/sonic.js插件实时变速变调，此插件计算量巨大，onProcess需要返回true开启异步模式
                        //可实时上传（发送）数据，配合Recorder.SampleData方法，将buffers中的新数据连续的转换成pcm上传，或使用mock方法将新数据连续的转码成其他格式上传，可以参考文档里面的：Demo片段列表 -> 实时转码并上传-通用版；基于本功能可以做到：实时转发数据、实时保存数据、实时语音识别（ASR）等

                        //可实时绘制波形（extensions目录内的waveview.js、wavesurfer.view.js、frequency.histogram.view.js插件功能）
                        //wave&&wave.input(buffers[buffers.length-1],powerLevel,bufferSampleRate);


                        if (this.localVars.eventEmitter) {
                            this.localVars.eventEmitter.emit("onVolumeChange", { type: "onVolumeChange", Volume: powerLevel });
                        }

                        this.localVars.currentVol = powerLevel;
                    }
                });
            }

            if (this.localVars.mp3Recorder) {
                this.localVars.mp3Recorder.open(() => {
                    this.localVars.mp3Recorder.start();
                    if (onStarted) {
                        onStarted();
                    }
                    this.setIsRecording(true);
                    this.localVars.startRecognizeCallback = { resolve, reject };
                }, (msg, isUserNotAllow) => {
                    //用户拒绝未授权或不支持
                    //console.log((isUserNotAllow?"UserNotAllow，":"")+"无法录音:"+msg);
                    reject(new Error(`${msg}`));
                });
                return;
            }

            this.localVars.recorder.onprogress = null;
            this.localVars.recorder.start().then(
                () => {
                    if (onStarted) {
                        onStarted();
                    }
                    this.setIsRecording(true);
                    // 开始录音
                    this.localVars.recorder.onprogress = params => {
                        //console.log("录音时长(秒)", params.duration);
                        //console.log("录音大小(字节)", params.fileSize);
                        //console.log("录音音量百分比(%)", params.vol);
                        // console.log('当前录音的总数据([DataView, DataView...])', params.data);
                        if (this.localVars.eventEmitter) {
                            this.localVars.eventEmitter.emit("onVolumeChange", { type: "onVolumeChange", Volume: params.vol });
                        }

                        this.localVars.currentVol = params.vol;
                    };

                    this.localVars.startRecognizeCallback = { resolve, reject };
                },
                error => {
                    this.localVars.recorder.stop();
                    // 出错了
                    DebugLogger.log(`${error.name} : ${error.message}`);
                    //reject(`${error.name} : ${error.message}`);
                    reject(new Error(`${error.name} : ${error.message}`));
                }
            );
        });
    };
    stopRecognize = () => {
        if (!this.localVars.isInitialized) {
            return;
        }
        if (!this.localVars.isRecording) {
            return;
        }

        if (this.localVars.mp3Recorder) {
            this.setIsRecording(false);
            this.localVars.mp3Recorder.stop((blob, duration) => {
                //简单利用URL生成本地文件地址，注意不用了时需要revokeObjectURL，否则霸占内存
                //此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
                //var localUrl=(window.URL||webkitURL).createObjectURL(blob);
                //console.log(blob,localUrl,"时长:"+duration+"ms");

                this.localVars.mp3Recorder.close();//释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
                this.localVars.mp3Recorder = null;

                const filename = this.localVars.wavFilePath.split("/").pop();
                localStorageFileHelper.setFile(this.localVars.wavFilePath, new File([blob], filename)).then(() => {
                    if (this.localVars.startRecognizeCallback) {
                        this.localVars.startRecognizeCallback.resolve();
                        this.localVars.startRecognizeCallback = null;
                    }
                });
            }, (msg) => {
                console.warn("录音失败:" + msg);
                this.localVars.mp3Recorder.close();
                this.localVars.mp3Recorder = null;
            });
            return;
        }

        this.localVars.recorder.stop();
        this.setIsRecording(false);
        const filename = this.localVars.wavFilePath.split("/").pop();
        localStorageFileHelper.setFile(this.localVars.wavFilePath, new File([this.localVars.recorder.getWAVBlob()], filename)).then(() => {
            if (this.localVars.startRecognizeCallback) {
                this.localVars.startRecognizeCallback.resolve();
                this.localVars.startRecognizeCallback = null;
            }
        });
    };
    recognizeFile = orgFile => {
        if (!this.localVars.isInitialized) {
            //return Promise.reject("Please init first");
            return Promise.reject(new Error("Please init first"));
        }

        return new Promise((resolve, reject) => {
            let filePromise = Promise.resolve(orgFile);
            if (_.isString(orgFile) && _.startsWith(orgFile, "/")) {
                filePromise = localStorageFileHelper.getFile(orgFile);
            } else if (_.isString(orgFile) && _.startsWith(orgFile, "~")) {
                const url = Helper.convertToAbsoluteUrl(orgFile);
                filePromise = new Promise((zreslove, zreject) => {
                    fetch(url, {})
                        .then(res => res.blob())
                        .then(blob => {
                            const filename = orgFile.split("/").pop();
                            const tempFile = new File([blob], filename);
                            zreslove(tempFile);
                        })
                        .catch(err => zreject(err));
                });
            } else if (_.isString(orgFile) && _.startsWith(orgFile, "http")) {
                filePromise = new Promise((zreslove, zreject) => {
                    fetch(orgFile, {})
                        .then(res => res.blob())
                        .then(blob => {
                            const filename = orgFile.split("/").pop();
                            const tempFile = new File([blob], filename);
                            zreslove(tempFile);
                        })
                        .catch(err => zreject(err));
                });
            }
            filePromise
                .then(file =>
                    this.getTimeLen(file)
                        .then(duration => {
                            if (this.localVars.needSplitAudio && duration > 55) {
                                this.spliceWavFile(file, duration)
                                    .then(files => {
                                        const response = [];
                                        this.recognizeSingleFile(files, { resolve, reject }, 0, response);
                                    })
                                    .catch(err => {
                                        return Promise.reject(err);
                                    });
                            } else {
                                if (duration < 0.1) {
                                    //for 0.1sec audio, we just return empty result is ok, no need to recognize
                                    this.setCurrentState(0);
                                    resolve({ audioToShort: true });
                                } else {
                                    this.localVars.serviceFactory.Recognize(this.localVars.currentConfig.referenceText, file, {
                                        onSuccess: (header, body) => {
                                            this.setCurrentState(0);
                                            resolve(body);
                                        },
                                        onFailure: (code, message) => {
                                            this.setCurrentState(0);
                                            //reject(code, message);
                                            reject(new Error(message || code));
                                        },
                                    });
                                }
                            }
                        })
                        .catch(err => {
                            return Promise.reject(err);
                        })
                )
                .catch(err => {
                    return Promise.reject(err);
                });
        });
    };
    recognizeSingleFile = (files, promise, currentIndex, response) => {
        if (currentIndex > files.length - 1) {
            this.setCurrentState(0);
            promise.resolve(_.join(response, ""));
            //try delete all files

            return;
        }
        const currentFile = files[currentIndex];
        this.localVars.serviceFactory.Recognize(this.localVars.currentConfig.referenceText, currentFile, {
            onSuccess: (header, body) => {
                //setCurrentState(0);
                //promise.resolve(body);
                response.push(body);
                this.recognizeSingleFile(files, promise, currentIndex + 1, response);
            },
            onFailure: (code, message) => {
                this.setCurrentState(0);
                //promise.reject(code, message);
                promise.reject(new Error(message || code));
                //try delete all files
            },
        });
    };
    destroy = () => {
        try {
            if (this.localVars.mp3Recorder) {
                this.localVars.mp3Recorder.close();
                this.localVars.mp3Recorder = null;
            }
            if (this.localVars.recorder) {
                let recorder = this.localVars.recorder;
                this.localVars.recorder = null;
                this.localVars.eventEmitter = null;
                recorder.destroy().then(() => {
                });
            }
            if (this.localVars.serviceFactory) {
                this.localVars.serviceFactory.destroy();
            }
        } catch (e) {
            DebugLogger.log(e.message);
        }
    };
    init = config => {
        if (this.localVars.recorder) {
            // NOTE: 题目切换太快时口语单元的componentDidMount和componentWillUnmount顺序会打乱, 导致多次destroy后又多次init
            console.warn('recorder already initialized');
            this.destroy();
            //alert('recorder already initialized');
            //return;
        }

        this.localVars.recorder = new Recorder({
            sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
            sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
            numChannels: 1, // 声道，支持 1 或 2， 默认是1
            // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
        });
        if (!this.localVars.eventEmitter) {
            this.localVars.eventEmitter = new NativeEventEmitter();
        }
        this.localVars.currentConfig = _.clone(config);
        //NOTE:: we only can use proxy server. since some api site has CORS issue
        this.localVars.serviceFactory = new SpeechServiceFactory(config.forReview, config.serviceType, this.localVars.currentConfig);
        this.localVars.needSplitAudio = !_.has(this.localVars.serviceFactory, "getIsSpeechEvaluation") ? true : !this.localVars.serviceFactory.getIsSpeechEvaluation();

        if (config.encodeFormat === 'mp3') {
            this.localVars.enableMp3Encoder = true;
        } else {
            this.localVars.enableMp3Encoder = false;
        }

        this.localVars.isInitialized = true;
    };
    setCurrentState = currentState => {
        if (this.localVars.currentState !== currentState) {
            if (this.localVars.eventEmitter) {
                this.localVars.eventEmitter.emit("onStatChange", { Stats: currentState });
            }
        }
        this.localVars.currentState = currentState;
    };
    setIsRecording = isRecording => {
        const previousRecording = this.localVars.isRecording;
        if (previousRecording !== isRecording) {
            if (previousRecording) {
                this.setCurrentState(0);
            } else {
                this.setCurrentState(1);
            }
        }
        this.localVars.isRecording = isRecording;
    };
    getCurrentState = fn => {
        callCallback(fn, this.localVars.currentState);
    };
    getHasWavFile = (orgPath, fn) => {
        localStorageFileHelper
            .getFile(orgPath)
            .then(file => {
                callCallback(fn, file instanceof File);
            })
            .catch(() => {
                callCallback(fn, false);
            });
    };
    getCurrentVolume = fn => {
        callCallback(fn, this.localVars.currentVol);
    };
    /**
     * get wav file path by path you set, use for multi-record case
     * @param wavPath
     * @param fn
     */
    getWavFilePath = (wavPath, fn) => {
        callCallback(fn, wavPath);
    };
    getWavFilePathNoCheck = (wavPath, fn) => {
        callCallback(fn, wavPath);
    };
    getLastWavFilePath = fn => {
        callCallback(fn, this.localVars.wavFilePath);
    };
    setReferenceText = text => {
        this.localVars.currentConfig.referenceText = text;
    };
    setEnableSpeechRecognize = enableOrNot => {
        this.localVars.currentConfig.enableSpeechRecognize = enableOrNot;
    };
    setWavFilePath = wavFilePath => {
        this.localVars.wavFilePath = wavFilePath;
        //DebugLogger.log(enableOrNot)
    };

    requirePermission = handler => {
        Recorder.getPermission().then(
            () => {
                callCallback(handler, true);
            },
            error => {
                //console.log(`${error.name} : ${error.message}`);
                callCallback(handler, false);
            }
        );
    };

    addEventListener = (eventName, method) => {
        if (this.localVars.eventEmitter) {
            return this.localVars.eventEmitter.addEventListener(eventName, method);
        }
    };
    removeEventListener = eventName => {
        if (this.localVars.eventEmitter) {
            return this.localVars.eventEmitter.removeEventListener(eventName);
        }
    };
    removeAllListeners = () => {
        if (this.localVars.eventEmitter) {
            return this.localVars.eventEmitter.removeAllListeners;
        }
    };
    getTimeLen = file => {
        return new Promise((resolve, reject) => {
            try {
                if (file.type === 'audio/mp3') {
                    // NOTE: mp3暂时跳过分割
                    resolve(30);
                    return;
                }

                const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                const fileReader = new FileReader();

                // Set up file reader on loaded end event
                fileReader.onloadend = () => {
                    const arrayBuffer = fileReader.result;
                    try {
                        // Convert array buffer into audio buffer
                        audioContext
                            .decodeAudioData(arrayBuffer)
                            .then(audioBuffer => {
                                // Do something with audioBuffer
                                //console.log(audioBuffer);
                                resolve(audioBuffer.duration);
                            })
                            .catch(err => reject(err));
                    } catch (e) {
                        reject(e);
                    }
                };

                fileReader.onerror = event => {
                    reject(fileReader.error);
                };
                //Load blob
                fileReader.readAsArrayBuffer(file);
            } catch (e) {
                reject(e);
            }
        });
    };

    spliceWavFile = (file, duration) => {
        return new Promise((resolve, reject) => {
            const files = [];
            file.arrayBuffer()
                .then(arrayBuffer => {
                    const buffer = arrayBuffer.slice(44); //skip top 44 wav header;
                    let start = 0;
                    let end = 0;
                    let count = 55;
                    let time = duration;
                    let newTime = time;
                    let internal = newTime - end;
                    while (internal > 0) {
                        if (internal < 55) {
                            const result = this.cutWavFile(buffer, duration, start, time, file.name);
                            if (result.success) {
                                files.push(result.blob);
                            }
                            end += count;
                        } else {
                            end += count;
                            const result = this.cutWavFile(buffer, duration, start, end, file.name);
                            if (result.success) {
                                files.push(result.blob);
                            }
                            start += count;
                        }
                        internal = newTime - end;
                    }
                    resolve(files);
                })
                .catch(err => reject(err));
        });
    };

    cutWavFile = (buffer, duration, start, end, fileName) => {
        const t1 = duration; //总时长(秒)
        if (start < 0 || end <= 0 || start >= t1 || end > t1 || start >= end) {
            return {
                success: false,
            };
        }
        const wavSize = buffer.byteLength; //音频数据大小（44为128kbps比特率wav文件头长度）
        const splitSize = (wavSize / t1) * (end - start); //截取的音频数据大小
        const skipSize = (wavSize / t1) * start; //截取时跳过的音频数据大小
        const blol = buffer.slice(skipSize, skipSize + splitSize);
        const wavBlob = encodeWAV(new DataView(blol), 16000, 16000, 1, 16);
        return {
            success: true,
            blob: new File([wavBlob.buffer], fileName + start + end + " .wav"),
        };
    };
}

export default RNSpeechRecognizeWeb;
